export enum SchoolTypeRelation {
  TYPE = 'Schulart',
  FORM = 'Schulform',
  PROFILE = 'Schulprofil',
  OPTIONAL_TYPE = 'Schulart_zusatz',
  OPTIONAL_FORM = 'Schulform_zusatz',
  OPTIONAL_PROFILE = 'Schulprofil_zusatz'
}